import React, { useState } from 'react'
import styled from 'styled-components'
import {
    FlexibleXYPlot as UnstyledFlexibleXYPlot,
    AreaSeries,
    LineSeries,
    Hint,
    MarkSeries,
} from 'react-vis'
import '../../../../node_modules/react-vis/dist/style.css'
import { Regular, MqDesktop } from 'streamr-ui/css/consts'

const FlexibleXYPlot = styled(UnstyledFlexibleXYPlot)`
    z-index: 1;
`

const HintTooltip = styled.div`
    background: #323232;
    border-radius: 4px;
    padding: 12px 15px;

    h3 {
        margin: 0;
        margin-bottom: 4px;
        padding: 0;
        font-weight: ${Regular};
        font-size: 16px;
        color: #ffffff;
    }

    p {
        margin: 0;
        padding: 0;
        color: #adadad;
        font-size: 12px;
    }
`

const BottomFade = styled.div`
    position: absolute;
    height: 61px;
    background: ${({ theme }) =>
        `linear-gradient(${theme.background}, ${theme.area}, ${theme.area})`};
    bottom: -1px;
    left: 0;
    right: 0;
`

const formatDate = ({ timestamp, showTime }) => {
    const date = new Date(timestamp)

    const monthName = date.toLocaleString('en-EN', {
        month: 'short',
    })

    if (showTime) {
        const timeStr = date
            .toLocaleString('en-EN', {
                timeStyle: 'short',
            })
            .toLowerCase()
        return `${timeStr} ${date.getDate()} ${monthName} ${date.getFullYear()}`
    }

    return `${date.getDate()} ${monthName} ${date.getFullYear()}`
}

const defaultTheme = {
    background: '#FFFFFF',
    area: '#FAFAFA',
    line: '#0324FF',
}

const UnstyledPriceGraph = ({ className, showTime, points, theme = defaultTheme }) => {
    const [hoveredValue, setHoveredValue] = useState(undefined)

    return (
        <div className={className}>
            <FlexibleXYPlot
                margin={{
                    left: 0,
                    right: 0,
                    top: 12,
                    bottom: 12,
                }}
                onMouseLeave={() => setHoveredValue(undefined)}
                colorType="literal"
            >
                <AreaSeries
                    animation
                    data={points}
                    curve={null}
                    color={theme.area || defaultTheme.area}
                    opacity={1}
                    onNearestX={(datapoint) => setHoveredValue(datapoint)}
                />
                <LineSeries
                    animation
                    data={points}
                    curve={null}
                    color={theme.line || defaultTheme.line}
                    opacity={1}
                    strokeStyle="solid"
                    strokeWidth="3"
                    onNearestX={(datapoint) => setHoveredValue(datapoint)}
                />
                {hoveredValue !== undefined && (
                    <Hint value={hoveredValue}>
                        <HintTooltip>
                            <h3>${Number(hoveredValue.y).toFixed(4)}</h3>
                            <p>
                                {formatDate({
                                    timestamp: hoveredValue.x,
                                    showTime: !!showTime,
                                })}
                            </p>
                        </HintTooltip>
                    </Hint>
                )}
                {hoveredValue !== undefined && (
                    <MarkSeries
                        data={[hoveredValue]}
                        color="#F75F0A"
                        size={6}
                        stroke="rgba(3, 36, 255, 0.2)"
                        strokeWidth={12}
                        style={{
                            paintOrder: 'stroke fill',
                        }}
                    />
                )}
            </FlexibleXYPlot>
            <BottomFade theme={theme} />
        </div>
    )
}

const PriceGraph = styled(UnstyledPriceGraph)`
    position: relative;
    height: 148px;

    @media ${MqDesktop} {
        height: 278px;
    }
`

export default PriceGraph
